import { Card } from '@foodsby/nutrient'
import cn from 'classnames'
import React, { useState } from 'react'

import { Segment } from '../common/Layout'
import SubscriptionUpgrade from './upgrades/SubscriptionUpgrade'

export const PanelUpgrades = () => {
  const [loading, setLoading] = useState(false)
  const [hidden, setHidden] = useState(true)

  return (
    <Card
      className={cn({
        hidden,
      })}
    >
      <Segment>
        <>
          <div className="row start-xs">
            <div className="col-xs-12">
              <SubscriptionUpgrade
                loading={loading}
                setHidden={setHidden}
                setLoading={setLoading}
              />
            </div>
          </div>
        </>
      </Segment>
    </Card>
  )
}

export default PanelUpgrades
